// client/src/pages/PricingPage.jsx
import React, { useState } from "react";
import LegalLayout from "./LegalLayout.jsx";
import LegalPageBody from "./LegalPageBody.jsx";
import Price from "../components/Price.jsx";
import { tLang } from "../i18n.js";
import { getLegalText } from "./legalContent.js";

const SUBTITLE = {
  de: "Wählen Sie die Option, die zu Ihrem Restaurant passt.",
  en: "Choose the option that fits your restaurant.",
  uk: "Оберіть варіант, який підходить вашому ресторану.",
  fr: "Choisissez l’option qui convient à votre restaurant.",
  nl: "Kies de optie die bij uw restaurant past.",
  pl: "Wybierz opcję, która pasuje do Twojej restauracji.",
  it: "Scegli l’opzione più adatta al tuo ristorante.",
  da: "Vælg den løsning, der passer til din restaurant.",
  es: "Elige la opción que mejor se adapte a tu restaurante.",
  no: "Velg alternativet som passer restauranten din.",
};

export default function PricingPage() {
  const [plan, setPlan] = useState("free");

  return (
    <LegalLayout pageKey="pricing">
      {({ lang }) => {
        const priceTa = (key, fallback = "") => {
          const safeFallback =
            fallback && typeof fallback === "object"
              ? getLegalText(fallback, lang)
              : fallback;

          return tLang(key, lang, safeFallback);
        };

        return (
          <LegalPageBody
            slug="pricing"
            lang={lang}
            afterSections={
              <>
                <div className="legal__price-block">
                  <h2>
                    {getLegalText(SUBTITLE, lang)}
                  </h2>
                </div>

                <Price value={plan} onChange={setPlan} ta={priceTa} />
              </>
            }
          />
        );
      }}
    </LegalLayout>
  );
}